export default [
  {
    path: '/manage/ydUnion', // 移动微医联合会员
    name: 'YDUNION',
    component: () => import('@/views/manage/ydUnion'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/manage/jyPackage', // 集运抗疫安心包
    name: 'JyPackage',
    component: () => import('@/views/manage/jyPackage'),
    meta: {
      loginNo: true,
      title: '微医健康通会员'
    }
  },
  {
    path: '/manage/app-download',
    name: 'APPDOWNLOAD',
    component: () => import('@/views/manage/appDownload'),
    meta: {
      loginNo: true,
      title: '一敦健康APP下载'
    }
  },
  {
    path: '/manage/community-announcements',
    name: 'COMMUNITYANNOUNCEMENTS',
    component: () => import('@/views/manage/communityAnnouncements'),
    meta: {
      loginNo: true
      // title: '社区公告详情'
    }
  },
  {
    path: '/manage/hospital-QRcode',
    name: 'HOSPITALQRCODE',
    component: () => import('@/views/manage/hospitalQRcode'),
    meta: {
      loginNo: true
      // title: '医院公众号二维码'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/manage.js